module.exports = __webpack_public_path__ + "img/internet.aa6bdc28.svg";